<template>
	<div class="bigtitle" :class="{'mClass': mClass}">
		{{bigtitle.CHN}}<span>{{bigtitle.ENG}}</span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			options: {},
		};
	},
	components: {

	},
	props: {
		bigtitle: {
			type: Object,
			default: () => ({})
		},
		mClass: {
			type: String,
			default: ''
		}
	},
	watch: {},
}
</script>
<style lang="scss" scope>
.bigtitle {
	font-family: 'PuHuiTi Heavy';
	font-size: 40px;
	&.mClass {
		margin: 30px 0 0 20px;
	}

	span {
		font-size: 21px;
		margin-left: 10px;
	}
}
</style>